import type { NoyauCode } from '@rosetta/shared';

/**
 * The noyau the analysis is about: the one of the URL when the translation has it; otherwise
 * (absent or unknown value) the first noyau of the translation that a quality control covers
 * (#34: the page does not open on "not available" when another noyau has its control), and
 * failing that the first noyau of the translation. `undefined` only for a translation with no
 * noyau, which a valid one never is. The order of `noyaux` is the one that breaks every tie.
 */
export function choisirNoyau(
  noyaux: readonly NoyauCode[],
  demande: NoyauCode | undefined,
  couverts: readonly NoyauCode[] = [],
): NoyauCode | undefined {
  return (
    noyaux.find((noyau) => noyau === demande) ??
    noyaux.find((noyau) => couverts.includes(noyau)) ??
    noyaux[0]
  );
}
